'use client';

import { useMemo } from 'react';
import { computeVariant } from '../utils/product-options';
import { useProduct } from './use-product';
import { useSelectionStore } from './private/use-selection-store';
import { useResolvedOptions } from './private/use-resolved-options';

/**
 * Returns the currently selected variant and its selected options. Just data,
 * so if you want to change options, use `useSelectionActions` instead.
 *
 * Requires <Suspense>.
 */
export function useSelectedVariant() {
  const { productData } = useProduct();
  const { additionalProducts } = useSelectionStore();
  const { selectedOptions } = useResolvedOptions();

  const variant = useMemo(
    () => computeVariant(productData, selectedOptions, additionalProducts),
    [productData, selectedOptions, additionalProducts]
  );

  return { selectedOptions, variant };
}
